var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2083_229295",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2083_229295)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.4781 14.475L7.85313 10.85C7.80313 10.8 7.76562 10.7458 7.74063 10.6875C7.71563 10.6292 7.70312 10.5667 7.70312 10.5C7.70312 10.3667 7.74896 10.25 7.84063 10.15C7.93229 10.05 8.05312 10 8.20312 10H15.8031C15.9531 10 16.074 10.05 16.1656 10.15C16.2573 10.25 16.3031 10.3667 16.3031 10.5C16.3031 10.5333 16.2531 10.65 16.1531 10.85L12.5281 14.475C12.4448 14.5583 12.3615 14.6167 12.2781 14.65C12.1948 14.6833 12.1031 14.7 12.0031 14.7C11.9031 14.7 11.8115 14.6833 11.7281 14.65C11.6448 14.6167 11.5615 14.5583 11.4781 14.475Z",
    fill: "#848C98"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconArrowDown);
export default __webpack_public_path__ + "static/media/icon_arrow_down.e5ea0eadc38c0e7fbfd3e2cf4870fb30.svg";
export { ForwardRef as ReactComponent };